import {IActionResponse} from "../../dal/BaseDAL";
import api, {BUNDLE_SUGGESTIONS_TYPE, LIST, PRODUCT_BUNDLE_REFS_TYPE} from "../Api";
import {IAcceptBundleSuggestionRequest, IBundleSuggestionRun, IDismissBundleSuggestionRequest} from "../../models/BundleSuggestions";

const bundleSuggestionApi = api.injectEndpoints({
    endpoints: (build) => ({
        // The latest AI-generated bundle suggestion run. The API returns 404 when no run has ever
        // been generated for the org, which callers treat as "no suggestions" rather than an error.
        getBundleSuggestions: build.query<IBundleSuggestionRun, void>({
            query: () => `/extensions/purchasehistory/bundleSuggestions`,
            providesTags: [{type: BUNDLE_SUGGESTIONS_TYPE, id: LIST}],
        }),
        generateBundleSuggestions: build.mutation<IActionResponse, {maxSuggestions?: number}>({
            query: (arg) => ({
                url: `/extensions/purchasehistory/bundleSuggestions/generate?maxSuggestions=${arg.maxSuggestions ?? 10}`,
                method: 'POST',
            }),
            invalidatesTags: [{type: BUNDLE_SUGGESTIONS_TYPE, id: LIST}],
        }),
        // body is optional: the card's quick-create path omits it (legacy, server picks defaults); the
        // details panel sends the user's edited include/quantity/markup configuration when present.
        acceptBundleSuggestion: build.mutation<IActionResponse, {runId: string, suggestionId: string, body?: IAcceptBundleSuggestionRequest}>({
            query: (arg) => ({
                url: `/extensions/purchasehistory/bundleSuggestions/${arg.runId}/suggestions/${arg.suggestionId}/accept`,
                method: 'POST',
                body: arg.body,
            }),
            invalidatesTags: [
                {type: BUNDLE_SUGGESTIONS_TYPE, id: LIST},
                {type: PRODUCT_BUNDLE_REFS_TYPE, id: LIST},
                {type: PRODUCT_BUNDLE_REFS_TYPE, id: 'TOP'},
            ],
        }),
        // body is optional: dismissal from either the card or the panel now goes through a reason
        // dialog, but a caller may still omit it (e.g. older/automated flows).
        dismissBundleSuggestion: build.mutation<IActionResponse, {runId: string, suggestionId: string, body?: IDismissBundleSuggestionRequest}>({
            query: (arg) => ({
                url: `/extensions/purchasehistory/bundleSuggestions/${arg.runId}/suggestions/${arg.suggestionId}/dismiss`,
                method: 'POST',
                body: arg.body,
            }),
            invalidatesTags: [{type: BUNDLE_SUGGESTIONS_TYPE, id: LIST}],
        }),
    })
})

export const {
    useGetBundleSuggestionsQuery,
    useGenerateBundleSuggestionsMutation,
    useAcceptBundleSuggestionMutation,
    useDismissBundleSuggestionMutation,
} = bundleSuggestionApi;
